import { render, staticRenderFns } from "./chinh-sach-ban-hang.vue?vue&type=template&id=0cbc207d&"
import script from "./chinh-sach-ban-hang.vue?vue&type=script&lang=js&"
export * from "./chinh-sach-ban-hang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports